export default "/shREUNI.2ed9bf82177093b5293f45d9367b9e51.png";